import React from "react";

// ──────────────────────────────────────────────────────
// TermsOfServiceBody.jsx — DocuAI·LoginHS 통합 이용약관 본문 (공용 SSoT)
//   DocuAI(문서 추출)·LoginHS(HS 품목분류)는 (주)로그인네트웍의 통합 서비스이므로
//   약관을 하나로 둔다. 도메인별 로고/브랜드만 다르고 약관 내용은 동일.
//   SignupPage·SnsSignupPage 등에서 <div 스크롤박스> 안에 넣어 사용.
// ──────────────────────────────────────────────────────

export const SERVICE_LABEL = "DocuAI·LoginHS";

const titleStyle = {
  fontSize: "13px",
  fontWeight: 700,
  color: "#16151a",
  margin: "14px 0 4px",
};

const TermsOfServiceBody = () => {
  return (
    <div
      style={{
        padding: "16px",
        lineHeight: "1.7",
        fontSize: "12.5px",
        color: "#374151",
      }}
    >
      <p style={{ margin: "0 0 8px", color: "#6b7280" }}>
        본 약관은 (주)로그인네트웍의 <strong>{SERVICE_LABEL}</strong> 통합
        서비스(문서 추출 DocuAI · HS 품목분류 LoginHS)에 공통 적용됩니다.
      </p>

      <h3 style={titleStyle}>제 1 조 (목적)</h3>
      <p>
        본 약관은 사용자가 주식회사 로그인네트웍(이하 "회사"라 함)에서 제공하는{" "}
        {SERVICE_LABEL} 통합 서비스(이하 "서비스"라 함)의 이용과 관련하여,
        회사와 사용자 간 또는 사용자간의 권리 및 의무, 책임사항, 서비스 이용조건
        및 절차 등 기본적인 사항을 정함으로써 상호간의 권리·의무 관계를 명확히
        하는 것을 목적으로 합니다.
      </p>

      <h3 style={titleStyle}>제 2 조 (용어의 정의)</h3>
      <ol style={{ paddingLeft: "20px", margin: "4px 0" }}>
        <li>
          <strong>사용자</strong>: 본 약관에 동의하고 회원 가입신청에 대한
          회사의 승낙을 받아 회사가 제공하는 서비스를 이용하는 자
        </li>
        <li>
          <strong>서비스</strong>: 주식회사 로그인네트웍이 제공하는{" "}
          {SERVICE_LABEL} 플랫폼(문서 추출·HS 품목분류 등 통합 기능) 및 이에
          따른 제반서비스. 하나의 계정으로 DocuAI·LoginHS 기능을 함께
          이용합니다.
        </li>
        <li>
          <strong>구독서비스</strong>: 정기적으로 이용료를 지불하고 일정 기간
          동안 서비스를 이용할 수 있는 서비스
        </li>
      </ol>

      <h3 style={titleStyle}>제 3 조 (이용계약의 성립)</h3>
      <p>
        "서비스" 이용계약은 "사용자"가 되고자 하는 자가 본 약관에 동의하고
        회사가 이를 승낙함으로써 체결됩니다. 하나의 계정으로 DocuAI·LoginHS
        기능에 모두 접근할 수 있습니다.
      </p>

      <h3 style={titleStyle}>제 4 조 (이용계약의 제한, 해지 등)</h3>
      <p>
        회사는 비정상적인 서비스 이용, 허위 정보, 중복 가입 등의 경우 가입을
        거부하거나 계약을 해지할 수 있습니다.
      </p>

      <h3 style={titleStyle}>제 5 조 (사용자의 의무)</h3>
      <p>
        사용자는 관련 법령 및 약관을 준수하여야 하며, 타인의 정보 도용, 해킹,
        저작권 침해 등의 행위를 하여서는 안 됩니다.
      </p>

      <h3 style={titleStyle}>제 6 조 (데이터 및 권리)</h3>
      <p>
        사용자가 업로드한 문서·입력 데이터의 권리는 사용자에게 있으며, 회사는
        서비스 제공·품질 개선 목적 범위에서만 이를 처리합니다. 개인정보의
        수집·이용 및 보관은 개인정보 처리방침을 따릅니다.
      </p>

      <h3 style={titleStyle}>제 7 조 (무상 제공 및 마케팅 정보 수신)</h3>
      <ol style={{ paddingLeft: "20px", margin: "4px 0" }}>
        <li>
          <strong>LoginHS HS 품목분류 서비스는 무상으로 제공</strong>되며, 이는
          회사의 마케팅·홍보 활동(서비스 안내·신규 기능 홍보·혜택 및 관련 제품
          소개 등)을 전제로 합니다.
        </li>
        <li>
          사용자는 가입 시 <strong>마케팅·홍보 정보 수신</strong>
          (이메일·문자(SMS)·전화·앱 알림 및 <strong>정기 뉴스레터</strong> 등)에
          동의하며, 이는 위 무상 제공의 조건입니다. 뉴스레터에는 세번분류 실무
          사례·관세 무역 소식·서비스 안내 등이 포함됩니다.
        </li>
        <li>
          사용자는 언제든지 수신 거부(옵트아웃)를 요청할 수 있습니다(각 이메일
          하단의 수신거부 링크 또는 계정 설정). 다만 마케팅 수신에 동의하지 않거나
          이를 철회하는 경우, 무상 제공 혜택의 전부 또는 일부가 제한될 수 있습니다.
        </li>
        <li>
          수집·이용되는 항목 및 보유 기간 등 세부 사항은 개인정보 처리방침을
          따릅니다.
        </li>
      </ol>

      <h3 style={titleStyle}>제 7 조의2 (무상 제공 기간 및 유료 전환)</h3>
      <ol style={{ paddingLeft: "20px", margin: "4px 0" }}>
        <li>
          LoginHS HS 품목분류 서비스의 무상 제공은{" "}
          <strong>가입일로부터 6개월간</strong> 기본 적용되며, 회사는 그 이후
          서비스의 전부 또는 일부를 유료로 전환할 수 있습니다.
        </li>
        <li>
          회사가 유료로 전환하는 경우, <strong>전환 예정일, 적용 요금제 및 할인율</strong>{" "}
          등 조건을 전환 예정일로부터 <strong>최소 30일 전</strong>에 이메일 등으로
          사전 고지합니다.
        </li>
        <li>
          유료 전환은 사용자가 유료 요금제 및 결제에 <strong>별도로 명시적으로 동의</strong>한
          경우에만 이루어지며, 동의하지 않은 사용자에게 요금이 자동으로 청구되지
          않습니다. 다만 이 경우 무상 이용이 제한되거나 종료될 수 있습니다.
        </li>
        <li>
          적용 요금제 및 할인율은 제10조 및 요금제 페이지의 최신 내용을 따릅니다.
        </li>
      </ol>

      <h3 style={titleStyle}>제 10 조 (구독서비스 및 이용료)</h3>
      <ul style={{ paddingLeft: "20px", listStyle: "disc", margin: "4px 0" }}>
        <li>개인 Starter: 월 11,000원</li>
        <li>개인 Pro: 월 33,000원</li>
        <li>개인 Premium: 월 55,000원</li>
      </ul>
      <p style={{ color: "#6b7280", margin: "4px 0 0" }}>
        ※ 이용료·구성은 변경될 수 있으며, 최신 내용은 요금제 페이지를 따릅니다.
      </p>

      <div
        style={{
          margin: "16px 0 0",
          paddingTop: "12px",
          borderTop: "1px solid #e5e7eb",
        }}
      >
        <p style={{ fontWeight: 600, margin: "0 0 4px" }}>
          고객지원: jmkim@logins.kr | 전화: 032-744-6000
        </p>
        <p style={{ margin: 0 }}>
          <strong>본 약관은 2025년 1월 1일부터 시행됩니다.</strong>
          <br />
          <span style={{ color: "#6b7280" }}>
            (2026년 7월 6일 개정 — 뉴스레터 수신 및 무상 제공 기간·유료 전환 조항
            추가)
          </span>
        </p>
      </div>
    </div>
  );
};

export default TermsOfServiceBody;
